"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PanelIconWrapper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const components_1 = require("@veeam/components");
exports.PanelIconWrapper = styled_components_1.default(components_1.View).attrs({
    align: components_1.VIEW_ALIGN.center,
    distribution: components_1.VIEW_DISTRIBUTION.center,
}) `
  width: ${({ theme }) => theme.spacing.m};
  height: ${({ theme }) => theme.spacing.m};
`;
exports.PanelIconWrapper.displayName = 'PanelIconWrapper';
//# sourceMappingURL=PanelIconWrapper.js.map